import React from 'react';
import { Field } from 'redux-form';
import Button from '@sizeid/commons/components/Button';

import Form from 'components/forms/Form';
import FormField, { FormFieldSet } from 'components/forms/FormField';
import { isSubmitDisabled } from 'utils/forms';

import { ForgottenPasswordRequestFormProps } from './types';

const ForgottenPasswordRequestForm: React.FC<ForgottenPasswordRequestFormProps> =
  props => (
    <Form id={props.id} onSubmit={props.handleSubmit}>
      <>
        <FormFieldSet>
          <Field
            name="email"
            type="email"
            placeholder={props.t('forgottenPasswordRequestForm.email')}
            component={FormField}
          />
        </FormFieldSet>
        <Button
          type="submit"
          disabled={isSubmitDisabled(props)}
          submitting={props.submitting}
        >
          {props.t('forgottenPasswordRequestForm.submit')}
        </Button>
      </>
    </Form>
  );

export default ForgottenPasswordRequestForm;
